export const getAppDisplayName = (appName, isPartner = false) => {
  if (!isPartner) {
    const defaultNames = {
      'application': 'Aplicação',
      'dfe': 'DF-e',
      'cm-frotas': 'CaçaMultas Frotas',
      'cm-taxas': 'CaçaMultas Taxas',
      'cm-embarcador': 'CaçaMultas Embarcador',
      'cm-crono': 'CaçaMultas Cronotacógrafo',
      'driver-indication': 'Indicação de Condutores'
    }
    return defaultNames[appName]
  }

  const partnerNames = {
    'application': 'Aplicação',
    'dfe': 'DF-e',
    'cm-frotas': 'Frotas',
    'cm-taxas': 'Taxas',
    'cm-embarcador': 'Embarcador',
    'cm-crono': 'Cronotacógrafo',
    'driver-indication': 'Indicação de Condutores'
  }
  return partnerNames[appName]
}
